//import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, Renderer2, Input } from '@angular/core';

//import * as ko from "knockout";
//import { Html } from "devexpress-reporting/dx-report-designer";

//@Component({
//  selector: 'app-admin',
//  templateUrl: './admin.component.html',
//  styleUrls: ['./admin.component.css']
//})
//export class AdminComponent implements OnInit {

//  constructor() { }

//  ngOnInit() {
//  }

//}




import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {customerSearch} from '../common/customerSearch.component'

/**
 * @title Dialog Overview
 */
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent {

    animal: string;
    name: string;

    constructor(public dialog: MatDialog) { }

    openDialog(): void {
        let dialogRef = this.dialog.open(customerSearch, {
            width: '250px',
            height: '250px',
            data: { name: this.name, animal: this.animal }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            this.animal = result;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts